export default {"src":"/_next/static/media/star.e1cf7769.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};